import { type DynamicIslandHostContext } from "../../dynamicIsland.registry";
import { type DynamicIslandVehicleRealtimePayload } from "../../dynamicIsland.types";

/** Default zoom when focusing the map on a selected vehicle. */
const VEHICLE_REALTIME_FOCUS_ZOOM = 17;

/** Camera animation duration (ms) for vehicle focus. */
const VEHICLE_REALTIME_FOCUS_DURATION_MS = 700;

/**
 * Recenters the map on the live vehicle position.
 * Called from the variant content's own click handler.
 *
 * @param payload Vehicle realtime island payload.
 * @param hostContext Host capabilities from the orchestrator.
 */
export function focusMapOnSelectedVehicle(
    payload: DynamicIslandVehicleRealtimePayload,
    hostContext: DynamicIslandHostContext,
): void {
    hostContext.updateCamera( {
        "center":   payload.lngLat,
        "zoom":     VEHICLE_REALTIME_FOCUS_ZOOM,
        "duration": VEHICLE_REALTIME_FOCUS_DURATION_MS,
        "pitch":    0,
        "bearing":  0,
    } );
}

/**
 * Toggles continuous center-only camera follow for the selected vehicle.
 *
 * @param hostContext Host capabilities from the orchestrator.
 */
export function toggleVehicleFollow( hostContext: DynamicIslandHostContext ): void {
    hostContext.toggleVehicleFollow();
}
